import OptionStep from "./OptionStep"

const options = [
    { label: "Google", value: "google" },
    { label: "Youtube", value: "youtube" },
    { label: "Linkedin", value: "linkedin" },
    { label: "Facebook", value: "facebook" },
    { label: "Word of Mouth", value: "word-of-mouth" },
    { label: "Friend/Colleague", value: "friend" },
    { label: "Others", value: "others" },
]

const Referrer = () => (
    <OptionStep
        heading="How did you hear about SellerDash?"
        description="Help us understand how you found out about us."
        options={options}
        field="referrer"
        nextStep="complete"
    />
)

export default Referrer
